module.exports = __webpack_public_path__ + "img/queen-henrietta-maria.04cd89d7.png";